// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const bronzong: PokeData = {
  "id": 437,
  "name": "bronzong",
  "height": 13,
  "weight": 1870,
  "base_experience": 175,
  "types": [
    PokeType.STEEL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "confusion",
    "hypnosis",
    "confuse-ray",
    "psywave",
    "feint-attack",
    "safeguard",
    "rain-dance",
    "sunny-day",
    "future-sight",
    "imprison",
    "weather-ball",
    "metal-sound",
    "extrasensory",
    "iron-defense",
    "block",
    "gyro-ball",
    "payback",
    "heal-block",
    "flash-cannon",
    "heavy-slam",
    "hex"
  ],
  "moves": [
    "tackle",
    "confuse-ray",
    "psywave",
    "rain-dance",
    "sunny-day",
    "future-sight",
    "metal-sound",
    "zen-headbutt",
    "psychic-terrain",
    "psy-ball",
    "steel-beam",
    "smart-strike",
    "metal-claw"
  ],
  "evolution_chain": {
    "id": 224,
    "item": null,
    "species": [
      {
        "name": "bronzor",
        "order": 460,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bronzong",
        "order": 461,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 436,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 33,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 171,
    "speed": 62,
    "ability_power": 167
  },
  "stat_changes": [],
  "catch_rate": 90,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
